import DailyHours from './DailyHours.js'
import HoursRange from './HoursRange.js'
import OperatingHours from './OperatingHours.js'
import WeeklyHours from './WeeklyHours.js'

export default {
  install( plg ) {
    plg.addPlugin( 'Model', { type : OperatingHours.TYPE, model : OperatingHours } )
    plg.addPlugin( 'Model', { type : WeeklyHours.TYPE, model : WeeklyHours } )
    plg.addPlugin( 'Model', { type : DailyHours.TYPE, model : DailyHours } )
    plg.addPlugin( 'Model', { type : HoursRange.TYPE, model : HoursRange } )
  }
}
